function Textarea({note, valid, onChangeHandler, node}) {
  return (
    <fieldset className="form-fieldset">
      <label htmlFor="newNote" className="form-label">Text</label>
      <textarea
        ref={node}
        className={`form-input textarea ${valid ? " " : "form-input-invalid"}`}
        id="newNote" 
        name="text" 
        rows="3"
        required 
        onChange={onChangeHandler} 
        value={note.text}>
      </textarea>
    </fieldset>
  );
}

export default Textarea;